import router from './router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { hasValidLoginStorage, clearInvalidLoginStorage } from '@/utils/auth'

NProgress.configure({ showSpinner: false })

router.beforeEach((to, from, next) => {
  NProgress.start()
  clearInvalidLoginStorage()
  // 已登录时访问登录页，回到首页
  if (hasValidLoginStorage() && to.path === '/login') {
    next({ path: '/' })
  } else {
    next()
  }
})

router.afterEach(() => {
  NProgress.done()
})
